var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 424.82 531.025",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .fil0 {fill:black;fill-rule:nonzero}\n   \n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M378.53 46.29c-61.71,-61.72 -161.86,-61.71 -223.57,0 -53.83,53.83 -60.66,137.04 -20.52,198.35l-22.19 21.4 46.53 46.53 21.4 -22.19c61.31,40.16 144.5,33.33 198.35,-20.52 61.72,-61.72 61.73,-161.85 0,-223.57zm-278.7 231.73l-89.39 86.19c-14.03,13.55 -13.79,36.37 0,50.17 13.8,13.79 36.61,14.03 50.17,0l86.19 -89.39 -46.97 -46.97zm258.91 -211.94c50.81,50.81 50.81,133.17 0,183.99 -50.82,50.82 -133.16,50.84 -184,0 -50.87,-50.87 -50.85,-133.13 0.01,-183.99 50.85,-50.84 133.16,-50.83 183.99,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M353.81 150.11c0.54,6.09 5.93,10.61 12.03,10.06 6.1,-0.54 10.62,-5.93 10.07,-12.03 -2.29,-25.5 -13.53,-49.49 -31.64,-67.59 -18.15,-18.16 -42.01,-29.28 -67.57,-31.61 -6.08,-0.56 -11.47,3.92 -12.03,10 -0.57,6.08 3.92,11.47 10,12.03 20.5,1.87 39.33,10.75 53.88,25.3 14.55,14.55 23.42,33.33 25.26,53.84z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.599f1ee1.svg";
export { ForwardRef as ReactComponent };